export const defaultNS = "mumiver.se";